var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMapPin = function SvgMapPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71,
    height: 70,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 35,
    r: 32.5,
    fill: "#fff",
    stroke: "#a2bc3a",
    strokeWidth: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1d490f",
    d: "M35.5 17c-7.2 0-13 5.58-13 12.4 0 4.6 5.45 14.5 10.02 21.97A3.47 3.47 0 0 0 35.5 53c1.23 0 2.35-.6 2.98-1.63C46.8 37.79 48.5 31.9 48.5 29.4c0-6.82-5.8-12.4-13-12.4Zm.4 32.97a.45.45 0 0 1-.4.22.45.45 0 0 1-.4-.22c-6.04-9.87-9.62-17.57-9.62-20.57 0-5.27 4.5-9.55 10.02-9.55 5.53 0 10.02 4.28 10.02 9.55 0 3-3.58 10.7-9.62 20.57Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d490f",
    d: "M35.5 23.22c-3.58 0-6.48 2.77-6.48 6.18 0 3.42 2.9 6.19 6.48 6.19 3.58 0 6.48-2.77 6.48-6.19 0-3.4-2.9-6.18-6.48-6.18Zm0 9.52A3.4 3.4 0 0 1 32 29.4a3.4 3.4 0 0 1 3.5-3.33A3.4 3.4 0 0 1 39 29.4a3.4 3.4 0 0 1-3.5 3.34Z"
  })));
};
export default SvgMapPin;